module.exports = __webpack_public_path__ + "img/icon-component-label_BookAudios.e7a3e6c4.svg";